<div class="cv-page">
  <div
    class="cv-1"
    [ngClass]="{ 'thumbnail-view': isThumbnail, 'full-view': !isThumbnail }"
  >
    <div class="nameAddress">
      <div>
        <h2 class="fullName">{{ data.firstName }} {{ data.lastName }}</h2>
        <p
          *ngIf="data.designation"
          class="designation"
        >
          {{ data.designation }}
        </p>
      </div>
      <div class="address">
        <ul class="pointers">
          <li *ngIf="data.contactDetails.number">
            <img
              src="../../../../../assets/images/grey-phone-icon.webp"
              alt="Phone"
              class="icon"
            />
            {{ data.contactDetails.number }}
          </li>
          <li *ngIf="data.contactDetails.email">
            <img
              src="../../../../../assets/images/grey-envelope-icon.webp"
              alt="Mail"
              class="icon"
            />
            {{ data.contactDetails.email }}
          </li>
          <li *ngIf="data.contactDetails.address">
            <img
              src="../../../../../assets/images/grey-pin-icon.webp"
              alt="Location"
              class="icon"
            />
            {{ data.contactDetails.address }}
          </li>
          <li *ngIf="data.contactDetails.linkedIn">
            <img
              src="../../../../../assets/images/grey-linkedin-icon.webp"
              alt="LinkedIn"
              class="icon"
            />
            {{ data.contactDetails.linkedIn }}
          </li>
        </ul>
      </div>
    </div>
    <div class="cv-container">
      <div class="cv-left">
        <section
          *ngIf="data.educations"
          class="cv-section"
        >
          <h3>EDUCATION</h3>
          <div
            *ngFor="let edu of data.educations"
            class="education-item"
          >
            <p class="degree-name">{{ edu.courseName }}</p>
            <p class="timeline">{{ edu.formattedDate }}</p>
            <p class="uni-name">{{ edu.universityName }}</p>
          </div>
        </section>
        <section
          class="cv-section"
          *ngIf="data.skills.length !== 0"
        >
          <h3>SKILLS</h3>
          <ul class="skills">
            <li *ngFor="let skill of data.skills">
              {{ skill }}
            </li>
          </ul>
        </section>
        <section
          class="cv-section"
          *ngIf="data.certifications.length !== 0"
        >
          <h3>CERTIFICATIONS</h3>
          <div
            class="experience-section"
            *ngFor="let cer of data.certifications"
          >
            <h4 class="job-title">{{ cer.name }}</h4>
            <p class="dates">{{ cer.date }}</p>
            <p class="issue-authority">{{ cer.authority }}</p>
          </div>
        </section>
        <section
          class="language-div"
          *ngIf="data.languages.length !== 0"
        >
          <h3>LANGUAGES</h3>
          <div class="language-item">
            <p *ngFor="let lang of data.languages">
              {{ lang }}
            </p>
          </div>
        </section>
      </div>
      <div class="cv-divider"></div>
      <div class="cv-right">
        <section class="cv-section">
          <h3>PROFESSIONAL SUMMARY</h3>
          <p class="summarise">{{ data.about }}</p>
        </section>
        <section class="cv-section">
          <h3>EXPERIENCE</h3>
          <div
            class="experience-section"
            *ngFor="let exp of data.experience"
          >
            <h4 class="job-title">{{ exp.Title }}</h4>
            <p class="dates">
              {{ exp.startDate }} - {{ exp.endDate ? exp.endDate : ' Present' }}
            </p>
            <ul class="description-points">
              <li *ngFor="let point of exp.descriptionPoints">
                {{ point }}
              </li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
